import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { decryptData } from '../Utils/Helper/helpers';

export const TeacherRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} component={(props) => (
    decryptData(localStorage.getItem('payload')) && decryptData(localStorage.getItem('payload')).role === 'teacher'
      ? (<Component {...props} />)
      : (<Redirect to="/" />)
  )} />
);

export default TeacherRoute;
